module.exports = __webpack_public_path__ + "img/Noah.a86941f2.png";